<template>
  <q-stepper
    ref="component"
    v-model="computedModelValue"
    active-icon="none"
    color="primary"
    header-class="no-border text-xs"
    alternative-labels
    flat
  >
    <template #message>
      <q-separator color="neutral-40" />
    </template>

    <slot name="default"></slot>
  </q-stepper>
</template>

<script setup>
const component = ref(null);
const props = defineProps({
  modelValue: {
    type: Number,
    default: 1,
  },
});

const emit = defineEmits(["update:modelValue"]);

defineExpose({
  component,
});

const computedModelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});
</script>
<style lang="scss" scoped>
.q-stepper--horizontal {
  :deep(.q-stepper__header) {
    min-height: 96px;

    .q-stepper__title {
      font-size: 12px;
    }
  }

  :deep(.q-stepper__header--alternative-labels) {
    .q-stepper__tab {
      min-height: 96px;
      padding: 24px 0;
    }
  }

  :deep(.q-stepper__step-inner) {
    padding: 0;
  }
}
</style>
